import { Injectable } from '@angular/core';
import { Storage } from '@angular/fire/storage';
import { NetworkService, ObservableService } from '@damofire/data-angular-commons';
import { Query, SearchResult } from '@damofire/data-commons';
import { Repair, RepairMedia } from './repair.dto';

@Injectable()
export abstract class RepairService extends ObservableService<Repair> {
  protected constructor(
    protected readonly networkService: NetworkService,
    protected readonly storage: Storage,
  ) {
    super(undefined);
  }

  abstract getImage(media: RepairMedia, type: 'thumb' | 'web' | 'original'): Promise<string>;
  abstract deleteMedia(media: RepairMedia): Promise<void>;
  abstract deleteIssue(issueId: string, repairId?: string): Promise<void>;
  abstract updateMedia(media: RepairMedia): Promise<void>;
  abstract getCsv(query: Query): Promise<string>;
  abstract buildCustomItemList(id: string, urlSearchString: string): Promise<string[]>;
  abstract upsert(repair: Partial<Repair>, repairId?: string): Promise<Repair>;
  abstract createRepairMedia(repairId: string, filename: string, bytes: string): Promise<void>;
  abstract get(repairId: string): Promise<Repair>;
  abstract search(id: string, sQuery: Query): Promise<SearchResult<Repair>>;
  abstract delete(id: string): Promise<void>;
  abstract deleteBatch(ids: string[]): Promise<void>;
  abstract getRepairsByUpright(divisionId: string, assetId: number | string): Promise<Repair[]>;
}
